import React from 'react';
import classNames from 'classnames';
import { getHasElementsInArray, getUserFullNameOrEmail } from 'utils';
import { useTranslation } from 'react-i18next';
import { ShareableLinkAnalyticsMemberEntry } from 'models/ShareableLink';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import usePastTime from 'hooks/usePastTime';
import SecureLinkFile from '../SecureLinkFile';

import './SecureLinkMember.styles.scss';

type SecureLinkMemberProps = {
  className?: string;
  entry: ShareableLinkAnalyticsMemberEntry;
};

const SecureLinkMember: React.FC<SecureLinkMemberProps> = (props) => {
  const { className, entry } = props;

  const { member, files } = entry || {};

  const { user, visitCount, lastAccessDate } = member || {};

  const classes = classNames('secure-link-member', 'white-panel', className);

  const { t } = useTranslation();

  const lastAccess = usePastTime()(lastAccessDate);

  return (
    <div className={classes}>
      <div className="secure-link-member__user">
        <AvatarWithInitials user={user} />
        <div>
          <p className="name">{getUserFullNameOrEmail(user)}</p>
          <p>{user?.email}</p>
        </div>

        <div>
          <p className="visits">
            {t(visitCount ? 'linkVisit' : 'dataRoomUC', { count: visitCount })}
          </p>
          <p>{t('lastAccessDate', { lastAccess: lastAccess || t('never') })}</p>
        </div>
      </div>

      {getHasElementsInArray(files) ? (
        files.map((file) => (
          <SecureLinkFile key={file.dataRoomNode?._id} file={file} />
        ))
      ) : (
        <p>{t('noFilesViewed')}</p>
      )}
    </div>
  );
};

export default SecureLinkMember;
